module.exports = __webpack_public_path__ + "media/images/rests-fill-topbar-0a598895d22016701e5960662038ee8e.svg";